<i18n>
	{
		"no": {
			"header" : "Leverandører",
			"refresh": "Oppdater",
			"editVendor": "Edit vendor",
			"name": "Name",
			"orgNo": "Org. No.",
			"postalPlace": "Postal Place",
			"postalCode": "Postal Code",
			"street": "Street",
			"serviceCode": "Service Code",
			"edi": "EDI"
		},
		"en": {
			"header": "Vendors",
			"refresh": "Refresh",
			"editVendor": "Rediger leverandør",
			"name": "Navn",
			"orgNo": "Org. Nr.",
			"postalPlace": "Poststed",
			"postalCode": "Postnummer",
			"street": "Gate",
			"serviceCode": "Servicekode",
			"edi": "EDI"
		}
	}
</i18n>
<template>
	<div>
		<t-vertical-panel class="vendors">
			<div slot="header" class="vendors-header">
				<t-panel-header size="md" icon="office" type="bp">
					{{ $t('header') }}
				</t-panel-header>
			</div>
			<div slot="sub-header" class="vendors-sub-header">
				<t-button
					iconBefore="refresh"
					appearance="minimal"
					@click="getVendors()"
				>{{ $t('refresh') }}</t-button>
			</div>
			<div class="vendors-content">
				<t-grid
					ref="grid"
					:columnDefinitions="columnDefinitions"
					:defaultColumnDefinition="defaultColumnDefinitions"
					:rowHeight="40"
					:items="vendors"
					localStorageId="vendors"
					@rowDoubleClick="editVendor"
				>

					<template #hasEdi="{ item }">
						<t-timpex-icon
							v-if="item.edipartId"
							:title="$t('editVendor')"
							icon="edi"
							type="bp"
							appearance="minimal"
							@click="editVendor(item.id)"
						/>
					</template>
					<template #edit="{ item }">
						<t-icon-button
							:title="$t('editVendor')"
							icon="annotation"
							type="bp"
							appearance="minimal"
							@click="editVendor(item.id)"
						/>
					</template>
				</t-grid>
			</div>
		</t-vertical-panel>
	
		<EditVendor
			:vendor="selectedVendor"
			:isDialogShown="showEditVendorDialog"
			@close="showEditVendorDialog = false"
			@save="executeVendorUpdate"
		/>
	</div>
</template>

<script>
import deepcopy from 'deepcopy';
import EditVendor from './EditVendor';
import { mapActions, mapGetters } from './store/vendors.store';
export default {
	components: {
		EditVendor
	},
	data() {
		return {
			columnDefinitions: [
				{
					field: 'name',
					displayName: this.$t('name'),
					width: 250
				},
				{
					field: 'orgNo',
					displayName: this.$t('orgNo'),
					width: 100
				},
				{
					field: 'postalPlace',
					displayName: this.$t('postalPlace'),
					width: 250
				},
				{
					field: 'postalCode',
					displayName: this.$t('postalCode'),
					width: 100
				},
				{
					field: 'street',
					displayName: this.$t('street'),
					width: 250
				},
				{
					field: 'serviceCode.internalCode',
					displayName: this.$t('serviceCode'),
					width: 50
				},
				{
					field: 'hasEdi',
					displayName: this.$t('edi'),
					width: 50
				},
				{
					field: 'edit',
					displayName: '',
					width: 50,
					sortable:false,
					resizable: false
				},
			],

			defaultColumnDefinitions: {
				resizable: true,
				headerFilterInputWithButton: true,

			},

			selectedVendor: null,
			showEditVendorDialog: false
		};
	},
	computed: {
		...mapGetters(['vendors']),
	},

	async mounted() {
		await this.getVendors();
		this.showEditVendorDialog = false;
	},

	methods: {
		...mapActions(['getVendors', 'updateVendor']),

		editVendor(id) {
			this.originalVendor = this.vendors.find( x => x.id === id);
			this.selectedVendor = deepcopy(this.originalVendor);
			this.showEditVendorDialog = true;
		},

		async executeVendorUpdate(updatedVendor) {
			await this.updateVendor({ originalVendor: this.originalVendor, updatedVendor });
		}
	},

};
</script>

<style lang="scss" scoped>
.vendors {
	.vendors-header {
		height: 100%;
		display: flex;
		align-items: center;
		padding-left: 15px;
	}
	.vendors-sub-header {
		display: flex;
		padding: 0px 15px;
		height: 100%;
		align-items: center;
		justify-content: flex-end;

		> button {
			margin: 10px;
		}
	}
	.vendors-content {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0px 5px;
	}
}
</style>